<template lang="html">
  <div class="wcc auth">
    <h2>Sign Up<slot></slot></h2>
    <form class="wcc">
      <div class="wcc input-group">
        <label for="to">Email</label>
        <input v-model="email" @blur="$v.email.$touch()" @focus="commitInput" :class="{invalid: $v.email.$error}" type="text" name="email" id="email" autocomplete="nope">
        <transition name="fade" mode="out-in">
          <p class="wcc error-text" v-if="$v.email.$error">Please provide a valid email address.</p>
          <p class="wcc error-text" v-else-if="errors.TOO_MANY_ATTEMPTS_TRY_LATER">We have blocked all requests from this device due to unusual activity. Try again later.</p>
          <p class="wcc error-text" v-else-if="errors.EMAIL_EXISTS">This email already exists.</p>
        </transition>
      </div>
      <div class="wcc input-group">
        <label for="to">Password</label>
        <input v-model="password1" @blur="$v.password1.$touch()" @focus="commitInput" :class="{invalid: $v.password1.$error}" type="password" name="password1" id="password1" autocomplete="new-password">
        <transition name="fade" mode="out-in">
          <p class="wcc error-text" v-if="$v.password1.$error">Your password must be at least 6 characters.</p>
        </transition>
      </div>

      <div class="wcc input-group">
        <label for="to">Confirm Password</label>
        <input v-model="password2" @blur="$v.password2.$touch()" @focus="commitInput" :class="{invalid: $v.password2.$error}" type="password" name="password2" id="password2" autocomplete="new-password">
        <transition name="fade" mode="out-in">
          <p class="wcc error-text" v-if="$v.password2.$error && password1 == '' && password2 == ''">This field is required.</p>
        </transition>
        <transition name="fade" mode="out-in">
          <p class="wcc error-text" v-if="$v.password2.$error && password1 != ''">The passwords do not match.</p>
        </transition>
      </div>
      <Button :invalid="$v.$anyError" :submitting="submitting" :value="'Send'" v-hammer:tap="signUpNewUser" ></Button>
    </form>
  </div>
</template>
<script>
  import Button from '@/components/Button.vue'
  import { required, email, minLength, sameAs } from 'vuelidate/lib/validators'
  import { mapState } from 'vuex'
  
  export default {
    data() {
      return {
        email: '',
        password1: '',
        password2: ''
      }
    },
    computed: {
      ...mapState('auth', {
        errors: state => state.signUp.errors,
        submitting: state => state.signUp.submitting,
      })
    },
    validations: {
      email: {
        required,
        email
      },
      password1: {
        required,
        minLength: minLength(6)
      },
      password2: {
        required,
        sameAsPassword1: sameAs('password1')
      }
    },
    methods: {
      signUpNewUser() {
        if (!this.$v.$anyError && !this.submitting) {
          this.$store.dispatch('auth/signUpNewUser', {
            email: this.email,
            password: this.password1,
            returnSecureToken: true
          })
        }
      },
      commitInput() {
        this.$store.dispatch('appInput/commitInput')
      }
    },
    mounted() {
      let vm = this
      // document.addEventListener('contextmenu', event => event.preventDefault())
      window.addEventListener("keydown", function(e) {
        // So that, if no calculator feed is active, 
        if (e.key == 'Enter' && !vm.$store.state.appInput.boundData) {
          e.preventDefault()
          vm.signUpNewUser()
        }
      })
    },
    components: {
      Button
    }
  }
</script>
<style lang="scss">
</style>